{
  "validation.required": "{{label}} jest polem wymaganym",
  "validation.minLength": "{{label}} musi mieć co najmniej {{min}} znaków",
  "validation.maxLength": "{{label}} nie może być dłuższe niż {{max}} znaków",
  "validation.contentTypeAlphanumeric": "{{label}} musi być alfanumeryczne",
  "validation.contentTypeDate": "{{label}} musi być datą",
  "validation.contentTypeDateBefore": "{{label}} musi być datą wcześniejszą niż {{date beforeDate}}",
  "validation.contentTypeDateAfter": "{{label}} musi być datą późniejszą niż {{date afterDate}}",
  "validation.contentTypeDatetime": "{{label}} musi być datą i godziną",
  "validation.contentTypeDatetimeBefore": "{{label}} musi być datą przed {{datetime beforeDate}}",
  "validation.contentTypeDatetimeAfter": "{{label}} musi być datą po {{datetime afterDate}}",
  "validation.contentTypeEmail": "{{label}} musi być e-mailem",
  "validation.contentTypeInteger": "{{label}} musi być liczbą",
  "validation.contentTypeNumber": "{{label}} musi być liczbą",
  "validation.contentTypeRegex": "{{label}} ma zły format",
  "validation.contentTypeText": "{{label}} musi być tekstem",
  "validation.contentTypeTime": "{{label}} musi być godziną",
  "validation.contentTypeUrl": "{{label}} musi być adresem internetowym",
  "select-element.default-option": "Wybierać…",
  "button-element.network-required": "Obecnie jesteś offline. Nawiąż połączenie sieciowe, aby kontynuować."
}